import { makeAutoObservable } from "mobx";

export default class UiStore {
  /**
   * Holds the current string value of the global search query.
   */
  currentSearchQuery: string = "";
  /**
   * Tracks the focus state of the global search bar.
   */
  isSearchBarFocused: boolean = false;

  constructor() {
    makeAutoObservable(this);
    console.warn(
      "Deprecation Warning: The legacy 'UiStore' (MobX) is in use. Please migrate to modern React state management for UI state as outlined in CONTRIBUTING.md."
    );
  }

  /**
   * Sets the search query value.
   * @param query The string to set as the current search query.
   */
  setCurrentSearchQuery(query: string) {
    this.currentSearchQuery = query;
  }

  /**
   * Clears the search query value.
   */
  clearSearchQuery() {
    this.currentSearchQuery = "";
  }

  /**
   * Sets the focus state of the global search bar.
   * @param isFocused Whether the search bar is focused.
   */
  setIsSearchBarFocused(isFocused: boolean) {
    this.isSearchBarFocused = isFocused;
  }
}
